module.exports = __webpack_public_path__ + "img/fire.eb03a10c.png";